module.exports = __webpack_public_path__ + "img/bizpay.1bb06904.png";